import MentorCard from '../components/ui/MentorCard';

const Mentors = () => {
  const mentors = [
    {
      name: "Naseer Shaik",
      initials: "NS",
      title: "Founder – PFSS | Product Manager | EdTech Senior Manager",
      expertise: ["Career Guidance", "Product Thinking", "Soft Skills", "EdTech Operations"],
      location: "Hyderabad, India",
      bio: "EdTech leader and career mentor with hands-on experience in product management, training, and student placement guidance.",
      learnings: [
        "Career clarity & decision-making",
        "Industry expectations & soft skills",
        "Product & EdTech career pathways",
        "Personal branding & communication"
      ],
      format: ["1:1 guidance sessions", "Live group mentorship"],
      available: true,
      color: "bg-[#0C7779]",
      hasImage: true,
      image: "/mentor-naseer.jpg"
    },
    {
      name: "Rhoda Adegboye",
      initials: "RA",
      title: "Media Professional & Storyteller",
      expertise: ["Media Strategy", "Storytelling", "Digital Inclusion"],
      location: "Africa (Global Programs)",
      bio: "Founder of NarraHub Group Ltd. Leads initiatives empowering young women with practical media and tech skills through holistic communication systems.",
      learnings: [
        "Strategic storytelling",
        "Media as a career tool",
        "Inclusive digital communication"
      ],
      format: ["Workshops", "Group mentorship"],
      available: true,
      color: "bg-[#249E94]",
      hasImage: true,
      image: "/mentor-rhoda.jpg"
    },
    {
      name: "Motaz Ali",
      initials: "MZ",
      title: "PhD Researcher | Agricultural & Water Management Expert",
      expertise: ["Agriculture", "Water Management", "Research", "Strategic Administration", "Economic Development"],
      location: "Middle East/Sudan",
      bio: "PhD researcher in Water Management with 18+ years of leadership experience. Combines agricultural expertise with strategic administration skills for holistic development solutions.",
      learnings: [
        "Water resource optimization",
        "Agricultural project management",
        "Strategic leadership",
        "Research methodologies",
        "Economic development strategies"
      ],
      format: ["Research guidance", "1:1 consulting", "Leadership workshops"],
      available: true,
      color: "bg-[#3BC1A8]",
      hasImage: true,
      image: "/mentor-motaz.jpg"
    },
    {
      name: "Peace Josiah",
      initials: "PJ",
      title: "Product & Graphic Designer",
      expertise: ["Product Design", "Graphic Design", "UI/UX", "Brand Identity"],
      location: "Global",
      bio: "Product and graphic designer with 4+ years experience creating user-centered digital products and compelling visual identities for startups and social-impact initiatives.",
      learnings: [
        "Product design fundamentals",
        "Graphic design principles",
        "Creative problem-solving",
        "Career guidance in design"
      ],
      format: ["Design workshops", "Portfolio reviews", "1:1 mentorship"],
      available: true,
      color: "bg-[#0C7779]",
      hasImage: true,
      image: "/mentor-peace.jpg"
    },
    {
      name: "Israel Ogundare",
      initials: "IO",
      title: "Video Editor | Storytelling Specialist",
      expertise: ["Video Editing", "Storytelling", "Adobe Premiere Pro", "Narrative Techniques"],
      location: "Nigeria",
      bio: "Intermediate video editor specializing in Adobe Premiere Pro with focus on storytelling and narrative techniques. Passionate about teaching video editing fundamentals.",
      learnings: [
        "Basics of video editing",
        "Storytelling techniques",
        "Adobe Premiere Pro",
        "Visual communication"
      ],
      format: ["Technical workshops", "1:1 sessions", "Editing tutorials"],
      available: true,
      color: "bg-[#249E94]",
      hasImage: true,
      image: "/mentor-israel.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-1 bg-[#F4FAF9] rounded-full text-[#0C7779] text-sm font-medium mb-3">
            MENTORSHIP PROGRAM
          </div>
          <h1 className="text-4xl font-bold mb-4 text-[#0F172A]">
            Learn From Real Professionals
          </h1>
          <p className="text-[#64748B] text-lg max-w-2xl mx-auto">
            GrowOn mentors are active industry professionals who focus on clarity,
            skills, and honest career guidance — not shortcuts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mentors.map((mentor, index) => (
            <MentorCard key={index} mentor={mentor} />
          ))}
        </div>

      </div>
    </div>
  );
};

export default Mentors;